import Vue from 'vue'
import Router from 'vue-router'
import { Toast } from 'vant'
import { setupWebViewJavascriptBridge, mobileLogin } from '@/utils'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router =  new Router({
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: function (resolve) { require(['@/pages/Index'], resolve) }, //首页
      meta: {
        title: '银贷优品',
        terminalType: 'h5'
      }
    },
    {
      path: '/rules/userrule',
      component: function (resolve) { require(['@/pages/rules/userrule'], resolve) }, // 用户协议
      meta: {
        title: '用户协议',
        terminalType: 'isLoginFalse'
      },
    },
    // 银贷优品 
    {
      path: '/applysuccess',
      component: function (resolve) { require(['@/pages/product/success'], resolve) }, // 申请成功
      meta: {
        title: '申请成功',
        terminalType: 'h5'
      },
    },
    {
      path: '/loan',
      component: function (resolve) { require(['@/pages/product/loan'], resolve) }, // 银贷优品
      meta: {
        title: '银贷优品',
        terminalType: 'h5',
      },
      children: [
        {
          path: 'exclusive',
          component: function (resolve) { require(['@/pages/product/loan/exclusive'], resolve) }, // 专属优选产品推荐
          meta: {
            title: '专属优选产品推荐',
            terminalType: 'h5'
          },
        },
        {
          path: 'verification',
          component: function (resolve) { require(['@/pages/product/loan/verification'], resolve) }, // 验证短信
          meta: {
            title: '银贷优品',
            terminalType: 'h5'
          },
        },
        {
          path: 'components',
          component: function (resolve) { require(['@/pages/product/loan/components'], resolve) }, // 信息首页
          meta: {
            title: '银贷优品',
            terminalType: 'h5',
            type: 'loan'
          },
          children: [
            {
              path: 'zmf',
              component: function (resolve) { require(['@/pages/product/loan/components/zhimafen'], resolve) }, // 芝麻分
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'vocation',
              component: function (resolve) { require(['@/pages/product/loan/components/vocation'], resolve) }, // 芝麻分
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'xyked',
              component: function (resolve) { require(['@/pages/product/loan/components/xinyongkaedu'], resolve) }, // 信用卡额度
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'dwgl',
              component: function (resolve) { require(['@/pages/product/loan/components/danweigongling'], resolve) }, // 单位工龄
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'sebao',
              component: function (resolve) { require(['@/pages/product/loan/components/shebao'], resolve) }, // 社保
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'gjj',
              component: function (resolve) { require(['@/pages/product/loan/components/gongjijin'], resolve) }, // 公积金
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'tbxx',
              component: function (resolve) { require(['@/pages/product/loan/components/toubaoxinxi'], resolve) }, // 投保信息
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'chechan',
              component: function (resolve) { require(['@/pages/product/loan/components/chechan'], resolve) }, // 车产
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'fangchan',
              component: function (resolve) { require(['@/pages/product/loan/components/fangchan'], resolve) }, // 房产
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'xueli',
              component: function (resolve) { require(['@/pages/product/loan/components/xueli'], resolve) }, // 学历
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'baseinfo',
              component: function (resolve) { require(['@/pages/product/loan/components/baseinfo'], resolve) }, // 基础信息
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'loanyx',
              component: function (resolve) { require(['@/pages/product/loan/components/loanyx'], resolve) }, // 贷款意向
              meta: {
                title: '填写资料',
                terminalType: 'h5'
              },
            },
            {
              path: 'checkmanager',
              component: function (resolve) { require(['@/pages/product/loan/components/checkManager'], resolve) }, // 选择为您服务的信贷经理
              meta: {
                title: '请选择信贷经理',
                terminalType: 'h5'
              },
            },
          ]
        },
      ]
    },
    {
      path: '/order',
      component: function (resolve) { require(['@/pages/product/order/myorder'], resolve) }, // 我的订单
      meta: {
        title: '我的订单',
        terminalType: 'h5'
      },
    },
    {
      path: '/order/detail',
      component: function (resolve) { require(['@/pages/product/order/detail'], resolve) }, // 订单详情
      meta: {
        title: '订单详情',
        terminalType: 'h5'
      },
    },
    {
      path: '/dld/:channel_lable',
      component: function (resolve) { require(['@/pages/dld/Index'], resolve) }, // 车贷在线
      meta: {
        title: '持牌机构贷款超市',
        terminalType: 'h5'
      },
    },
    {
      path: '*',
      component: function (resolve) { require(['@/components/404'], resolve) }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // html title
  // console.log(to.query)
  const channel = to.query.channel_lable
  const localChannel = window.localStorage.getItem('channel')
  let userToken = window.localStorage.getItem('token')
  if(channel) {
    window.localStorage.setItem('channel', channel)
  }
  document.title = to.meta.title;
  if(channel === 'ZH' || localChannel === 'ZH') {
    document.title = '银贷优品'
  } else {
    document.title = '车贷在线'
  }
  if(channel === 'cdol' || localChannel === 'cdol') {
    if(!!window.webkit) {
      console.log('window.webkit')
      setupWebViewJavascriptBridge(function(bridge) {
        /* Initialize your app here */
        bridge.registerHandler('callback', function(data, responseCallback) {
          responseCallback(data)
        })
        bridge.callHandler('iosBridge', {'key':'getUserToken'}, function responseCallback(res) {
          userToken = res.token
          if(!!userToken) {
            window.localStorage.setItem('token', userToken)
            next()
          }else{
            mobileLogin()
            next()
          }
        })
      })
    } 
    if(!!window.Android) {
      userToken = window.Android.getUserToken()
      if (!!userToken) {
        window.localStorage.setItem('token', userToken)
        next()
      } else {
        mobileLogin()
        next()
      }
    }
  }
  next()
})

router.afterEach(route => {
  Toast.clear()
})

export default router

